// extracted by mini-css-extract-plugin
export default {"input":"input_input__EBh3D","inputIcon":"input_inputIcon__p9LWJ","closeInput":"input_closeInput__4jl7w","icon":"input_icon__qgGVQ","close":"input_close__E-eAd"};